// TodoList.js
import React, { useState } from 'react';
import { FaTrash } from 'react-icons/fa';

const TodoList = ({ id, onRemove }) => {
  const [tasks, setTasks] = useState(
    JSON.parse(localStorage.getItem(`tasks-${id}`)) || []
  );
  const [newTask, setNewTask] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [listTitle, setListTitle] = useState('Todo List');

  const addTask = () => {
    if (newTask.trim() !== '') {
      const updatedTasks = [...tasks, { text: newTask, done: false }];
      setTasks(updatedTasks);
      localStorage.setItem(`tasks-${id}`, JSON.stringify(updatedTasks));
      setNewTask('');
    }
  };

  const toggleTask = (index) => {
    const updatedTasks = [...tasks];
    updatedTasks[index].done = !updatedTasks[index].done;
    setTasks(updatedTasks);
    localStorage.setItem(`tasks-${id}`, JSON.stringify(updatedTasks));
  };

  const removeList = () => {
    // Remove list data from localStorage
    localStorage.removeItem(`tasks-${id}`);
    onRemove(id);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      addTask();
    }
  };

  return (
    <div className="todo-list">
      {editMode ? (
        <input
          type="text"
          value={listTitle}
          onChange={(e) => setListTitle(e.target.value)}
          onBlur={() => setEditMode(false)}
          autoFocus
          className="list-title"
        />
      ) : (
        <h2 onClick={() => setEditMode(true)}>{listTitle}</h2>
      )}
      <ul>
        {tasks.map((task, index) => (
          <li key={index}>
            <input
              type="checkbox"
              checked={task.done}
              onChange={() => toggleTask(index)}
            />
            <span style={{ textDecoration: task.done ? 'line-through' : 'none' }}>
              {task.text}
            </span>
          </li>
        ))}
        <li className="enter-task">
          <input
            type="text"
            value={newTask}
            onChange={(e) => setNewTask(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Enter a new task"
          />
          <button onClick={addTask} className="task-button">
            Add Task
          </button>
        </li>
      </ul>
      <button onClick={removeList} className="remove-button">
        <FaTrash />
      </button>
    </div>
  );
};

export default TodoList;
